import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-science-day',
  templateUrl: './science-day.component.html',
  styleUrls: ['./science-day.component.scss']
})
export class ScienceDayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
